const emptyTrace = () => ({
  version: 1,
  steps: [],
  activeStepCode: null,
  highlights: [],
});

export const settleActivity = (activity, status) => {
  const trace = activity?.trace || emptyTrace();
  const settleNode = (node, isChild = false) => {
    let settledStatus = node.status;
    if (node.status === "running") {
      settledStatus =
        status === "completed" && (isChild || node.code !== "answer")
          ? "failed"
          : status;
    }
    return {
      ...node,
      status: settledStatus,
      children: Array.isArray(node.children)
        ? node.children.map((child) => settleNode(child, true))
        : [],
    };
  };
  return {
    trace: {
      ...trace,
      steps: trace.steps.map((step) => settleNode(step)),
    },
  };
};
